import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { DonutFillChart } from 'components/patterns/Charts'
import { MAX_CAN_INPUTS, MAX_SWITCH_INDICATORS } from 'utils/constants.js'
import withStyle, {
  LabeledChartStyled,
  LabelStyled,
} from './ModuleSummary.style.js'

const ModuleSummaryMetrics = ({
  moduleName,
  logicCount,
  maxLogics,
  timerCount,
  maxTimers,
  maxCanInputs = MAX_CAN_INPUTS,
  canInputsCount,
  switchIndicatorCount,
  maxSwitchIndicators = MAX_SWITCH_INDICATORS,
  showSwitchIndicator,
  showCanInputs,
}) => (
  <>
    <LabeledChartStyled>
      <DonutFillChart
        count={logicCount}
        total={maxLogics}
        id={`${moduleName}-logics`}
      />
      <LabelStyled>
        {strings.of} {maxLogics}
        <br />
        {strings.logic_sets}
      </LabelStyled>
    </LabeledChartStyled>
    <LabeledChartStyled>
      <DonutFillChart
        count={timerCount}
        total={maxTimers}
        id={`${moduleName}-timers`}
      />
      <LabelStyled>
        {strings.of} {maxTimers}
        <br />
        {strings.timers}
      </LabelStyled>
    </LabeledChartStyled>
    {showCanInputs && (
      <LabeledChartStyled>
        <DonutFillChart
          count={canInputsCount}
          total={maxCanInputs}
          id={`${moduleName}-canInputs`}
        />
        <LabelStyled>
          {strings.of} {maxCanInputs}
          <br />
          {strings.can_inputs}
        </LabelStyled>
      </LabeledChartStyled>
    )}
    {showSwitchIndicator && (
      <LabeledChartStyled>
        <DonutFillChart
          count={switchIndicatorCount || 0}
          total={maxSwitchIndicators || MAX_SWITCH_INDICATORS}
          id={`${moduleName}-switchIndicators`}
        />
        <LabelStyled>
          {strings.of} {maxSwitchIndicators || MAX_SWITCH_INDICATORS}{' '}
          {strings.indicators}
        </LabelStyled>
      </LabeledChartStyled>
    )}
  </>
)

ModuleSummaryMetrics.propTypes = {
  /** Make sure to comment */
  /** Name of the module (e.g. XMC/2) */
  moduleName: PropTypes.string,
  /** number of logicsets used by all feaures using this module on the vehicle */
  logicCount: PropTypes.number,
  /** max logicsets that can be used in total by all feaures using this module on the vehicle */
  maxLogics: PropTypes.number,
  /** number of timers used by all feaures using this module on the vehicle */
  timerCount: PropTypes.number,
  /** max timers that can be used in total by all feaures using this module on the vehicle */
  maxTimers: PropTypes.number,
  /** number of pins used by all feaures using this module on the vehicle */
  pinCount: PropTypes.number,
  /** max pins that can be used in total by all feaures using this module on the vehicle */
  maxPins: PropTypes.number,
  /** max switches that can be used in total by all feaures using this module on the vehicle */
  maxSwitchIndicators: PropTypes.number,
  /** number of switches used by all feaures using this module on the vehicle */
  switchIndicatorCount: PropTypes.number,
  /** To ad extra marginBottom to 1st item when atleast one module has switch indicators */
  addExtraSpacingInMetrics: PropTypes.bool,
  /** for appVariant >= 118 switchIndicator count should be shown */
  showSwitchIndicator: PropTypes.bool,
  /** from XMC3-8 */
  showCanInputs: PropTypes.bool,
  maxCanInputs: PropTypes.number,
  canInputsCount: PropTypes.number,
}

export default withStyle(ModuleSummaryMetrics)
